const authors = [
    {
        "name": "Cierra Beck",
        "src": "",
        "alt": "photo of Cierra",
        "title": "Founder, typography lead",
        "bio": "bio coming soon!"
    },
    {
        "name": "Claire Hollis",
        "src": "",
        "alt": "photo of Claire",
        "title": "Head of creative writing and Smart eBook project", 
        "bio": "bio coming soon!"
    },
    {
        "name": "Julie Chen",
        "src": "",
        "alt": "photo of Julie",
        "title": "Head of photography and Creative Calisthenics", 
        "bio": "bio coming soon!"
    },
]

export default authors